import { apiFetch } from "./api";

/**
 * Public holidays (FEAT-2026-017 phase 1).
 *
 * A holiday suppresses attendance *expectation* for the sites it covers: no
 * missed-attendance chase, and the day is not counted as expected. It never
 * blocks a check-in (BR-202) — someone who works a holiday is recorded
 * normally.
 */
export interface Holiday {
  id: string;
  /** `YYYY-MM-DD` in the tenant's timezone. */
  date: string;
  name: string;
  notes: string | null;
  /** Empty = the whole organisation, including employees with no site. */
  sites: Array<{ id: string; code: string; name: string }>;
  createdAt: string;
}

export interface HolidayBody {
  date: string;
  name: string;
  notes?: string;
  /** Omit or send empty for organisation-wide. */
  siteIds?: string[];
}

export const holidaysApi = {
  list: (params: { dateFrom?: string; dateTo?: string; siteId?: string } = {}) => {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) if (v) q.set(k, v);
    const qs = q.toString();
    return apiFetch<Holiday[]>(`/holidays${qs ? `?${qs}` : ""}`);
  },

  create: (body: HolidayBody) =>
    apiFetch<Holiday>("/holidays", { method: "POST", body }),

  update: (id: string, body: Partial<HolidayBody>) =>
    apiFetch<Holiday>(`/holidays/${id}`, { method: "PATCH", body }),

  remove: (id: string) =>
    apiFetch<{ id: string }>(`/holidays/${id}`, { method: "DELETE" }),
};
